import {useEffect, useRef, useState} from "react";
import toggleFavorite from "../../api/favorites/toggleFavorite";
import {stopEvent} from "../../utils/events";
import {url} from "../../utils/urls";

const StarItem = (
  {
    className = "",
    goodsData = {},
    favoKey = "favo_goods",
    starWidth = "22px",
  }) => {
  const [loading, setLoading] = useState(true);
  const [goods, setGoods] = useState({});
  const updatingFavo = useRef(false);

  useEffect(() => {
    if (!loading) {
      return;
    }
    setGoods(goodsData);
        setLoading(false);
  }, [loading]);


  /**
   * お気に入り切り替え
   */
  const handleFavorite = (e, goods_code) => {
    if(updatingFavo.current) return;
    updatingFavo.current = true;
    toggleFavorite({
      goods_code: goods_code,
      callSuccess: (result) => {
        setGoods((prevState) => {
          let postState = {...prevState};
          postState[favoKey] = result["favo"];
          return postState;
        });
      },
      callFinally: () => {
        updatingFavo.current = false;
      },
    });
    stopEvent(e)
  }
  return (
    loading ?
      <div></div>
      :
      <div className={"star" + " " + className}
           style={{width: starWidth}}
           onClick={(e) => handleFavorite(e, goods["goods_code"])}>
        {goods[favoKey] ?
          <img src={url("/img/common/icon13.png")} alt="star" className="img-fluid" />
          :
          <img src={url("/img/common/icon08.png")} alt="star" className="img-fluid" />
        }
      </div>
  )
};
export default StarItem;